module.exports = __webpack_public_path__ + "static/media/service3.ee79ae24.png";